let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eNrOy")).then(() => parcelRequire('eGg7H'));